import { Box, Row, Typography, ViewContainer } from 'components/AORedesign';
import { Feature } from 'components/Feature';
import featureFlags from 'constants/featureFlags';
import React from 'react';
import BillingInquiry from './BillingInquiry';
import FormsAndRequests from './FormsAndRequests';
import GuidesAndContacts from './GuidesAndContacts';
import PaymentManagement from './PaymentManagement';

const Billing = () => {
  return (
    <ViewContainer title="Billing">
      <Typography color="primary" component="div">
        <Box fontWeight="fontWeightBold">
          To view the latest billing and policy details for your Main Street Commercial+ policies, click &apos;Policy View/Change&apos; in the upper right
          corner, then select &apos;Commercial&apos;
        </Box>
      </Typography>
      <Box p={1} />
      <BillingInquiry />
      <Feature allowed={featureFlags.ACCESS_PAYMENT_MANAGEMT}>
        <PaymentManagement />
      </Feature>
      <Row spacing={3}>
        <FormsAndRequests />
        <GuidesAndContacts />
      </Row>
    </ViewContainer>
  );
};

export default Billing;
